import React, { useState, Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { LineBoxContainer } from "../../../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../../../Button/CalendarLineBtn";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import LineBtn from "../../../../Button/LineBtn";
import FilterIcon from "../../../../DefaultStyles/FilterIcon";
import CalendarModal from "../../../../Modal/CalendarModal";
import { CalendarLine } from "../../../Party/ChatInfo/ChatSearch/RecentChat";

interface UserDetailPayHistoryFilterProps {
  setFilter: Dispatch<SetStateAction<{ startDate: string; endDate: string }>>;
  refreshPage: () => void;
}

export default function UserDetailPayHistoryFilter({
  setFilter,
  refreshPage,
}: UserDetailPayHistoryFilterProps) {
  const [startDate, setStartDate] = useState("날짜 선택");
  const [startDateClick, setStartDateClick] = useState(false);
  const [endDate, setEndDate] = useState("날짜 선택");
  const [endDateClick, setEndDateClick] = useState(false);

  return (
    <UserDetailPayHistoryFilterContainer>
      <FilterIcon maxWidth={0} />

      <LineBoxContainer>
        <CalendarLineBtn
          onClickEvent={() => setStartDateClick(true)}
          value={startDate}
          initValue={"날짜 선택"}
          minWidth={155}
        />

        {startDateClick && (
          <CalendarModal
            sPosition={"absolute"}
            closeEvent={() => setStartDateClick(false)}
            changeEvent={(date: string) => setStartDate(date)}
            isFutureDisable={true}
          />
        )}
      </LineBoxContainer>

      <CalendarLine />

      <LineBoxContainer>
        <CalendarLineBtn
          onClickEvent={() => setEndDateClick(true)}
          value={endDate}
          initValue={"날짜 선택"}
          minWidth={155}
          disabled={startDate === "날짜 선택"}
        />

        {endDateClick && (
          <CalendarModal
            sPosition={"absolute"}
            closeEvent={() => setEndDateClick(false)}
            changeEvent={(date: string) => setEndDate(date)}
            dateValue={startDate}
            isAfterStartDate={true}
          />
        )}
      </LineBoxContainer>

      <ConfirmBtn
        btnText="적용"
        btnColor="mint"
        btnHeight={38}
        isDisabled={endDate === "날짜 선택"}
        btnClickEvent={() => {
          refreshPage();
          setFilter({
            startDate: startDate !== "날짜 선택" ? startDate : "",
            endDate: endDate !== "날짜 선택" ? endDate : "",
          });
        }}
      />

      <LineBtn
        btnText="초기화"
        btnColor="mint"
        icon="refresh"
        btnHeight={38}
        disabled={endDate === "날짜 선택"}
        btnClickEvent={() => {
          setStartDate("날짜 선택");
          setEndDate("날짜 선택");
          setFilter({
            startDate: "",
            endDate: "",
          });
        }}
      />
    </UserDetailPayHistoryFilterContainer>
  );
}

const UserDetailPayHistoryFilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
`;
